export default "__VITE_ASSET__DRD0vtzh__"